import axios from 'axios';
import React, { ReactElement, useState, useRef } from 'react';
import { FileUploadContainer } from './EncryptWrapper.styles';
import { PasswordManager } from './PasswordManager/PasswordManager';
import { PdfUploader } from './PdfUploader/PdfUploader';
const defaultProps = {};
type PdfEncryptWrapperProps = {} & typeof defaultProps;

export const PdfEncryptWrapper = ({}: PdfEncryptWrapperProps): ReactElement => {
	const fileInputField = useRef<HTMLInputElement>(null);
	const [file, setFile] = useState<any>();
	const [isSet, setIsSet] = useState<boolean>(false);
	const [passwords, setPasswords] = useState<any>({
		password: '',
		confirmPassword: ''
	});

	const handleUploadBtnClick = () => {
		if (fileInputField.current !== null) {
			fileInputField.current.click();
		}
	};

	const onPasswordChange = (e: any) => {
		e.preventDefault();
		setPasswords({ ...passwords, [e.target.name]: e.target.value });
	};
	const onChange = (e: any) => {
		setFile(e.target.files[0]);
		setIsSet(true);
	};
	const onUploadProgress = (event: any) => {
		console.log('here');
		const percentCompleted = Math.round((event.loaded * 100) / event.total);
		console.log('onUploadProgress', percentCompleted);
	};
	const onSubmit = async () => {
		console.log('ee');
		const formData = new FormData();
		console.log(passwords);
		formData.append('File', file);
		formData.append('passwords', JSON.stringify(passwords));
		try {
			const response = await axios.post(
				'http://localhost:5000/pdf-encrypt',
				formData,
				{ onUploadProgress }
			);
			console.log(response);
		} catch (err) {
			console.log(err);
		}
	};
	return (
		<>
			<div>
				<h1 style={{ textAlign: 'center' }}>
					Encrypt PDF - Not connected to backend yet
				</h1>
			</div>
			<FileUploadContainer isSet={isSet}>
				{/* <input
					type='file'
					name='Add PDF'
					id='PDF'
					onChange={onChange}
				/> */}

				{isSet ? (
					<PasswordManager
						onPasswordChange={onPasswordChange}
						onSubmit={onSubmit}
						fileName={file.name}
					/>
				) : (
					<PdfUploader
						handleUploadButtonClick={handleUploadBtnClick}
						onChange={onChange}
						fileInputRef={fileInputField}
					/>
				)}
				{/*  */}
			</FileUploadContainer>
		</>
	);
};
PdfEncryptWrapper.defaultProps = defaultProps;
